import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ReferenceWithNumber } from '@treetop/shared/model';

import { ReferenceComponent } from './reference.component';

@Component({
  selector: 'tt-reference-list',
  templateUrl: './reference-list.component.html',
  styleUrls: ['./reference-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReferenceComponent],
})
export class SmartbookReferenceListComponent {
  public references = input<ReferenceWithNumber[]>([]);
}
